<script setup>
import {
  SelectContent,
  SelectItem,
  SelectItemIndicator,
  SelectItemText,
  SelectPortal,
  SelectRoot,
  SelectTrigger,
  SelectValue,
  SelectViewport,
} from 'reka-ui'

import { LazyMotion, m, AnimatePresence } from "motion-v"
const loadFeatures = () => import("~/composables/motionFeatures.js")
    .then(res => res.default)

defineProps({
  items: {
    type: Array,
    default: [
      {
        name: '',
        value: '0'
      }
    ]
  },
  autoWidth: {
    type: Boolean,
    default: true
  },
  placeholder: {
    type: String,
    default: '-- انتخاب کنید --'
  },
  disabled: {
    type: Boolean,
    default: false
  }
})
const model = defineModel();
</script>

<template>
  <SelectRoot v-model="model" dir="rtl">
    <SelectTrigger as-child :disabled="disabled">
      <slot/>
    </SelectTrigger>
    <SelectPortal>
      <LazyMotion :features="loadFeatures" strict>
        <AnimatePresence>
          <SelectContent
              as-child
              position="popper"
              align="center"
              :bodyLock="false"
              :side-offset="8"
              :style="autoWidth ? 'width: var(--reka-select-trigger-width)' : ''"
              :class="[$attrs.class ,'shadow-normal bg-white p-3 border border-light rounded-xl z-50']">
            <m.div
                :initial="{ opacity: 0, scale: 0.9 }"
                :animate="{ opacity: 1, scale: 1 }"
                :exit="{ opacity: 0, scale: 0.9 }"
                :transition="{ duration: 0.15, ease: [0.16, 1, 0.3, 1] }"
            >
              <SelectViewport>
                <SelectItem
                    v-for="(item, index) in items"
                    :key="index"
                    :value="item.value"
                    class="text-label font-medium rounded-lg flex items-center justify-between px-2.5 py-2 relative select-none data-[highlighted]:bg-brand/10 data-[highlighted]:text-brand-darker cursor-pointer focus:outline-0 transition-all"
                >
                  <SelectItemIndicator class="absolute left-2.5 inline-flex items-center justify-center">
                    <Icon name="linear:check" class="size-4 "/>
                  </SelectItemIndicator>
                  <SelectItemText>{{ item.name }}</SelectItemText>
                </SelectItem>
              </SelectViewport>
            </m.div>
          </SelectContent>
        </AnimatePresence>
      </LazyMotion>
    </SelectPortal>
  </SelectRoot>
</template>

<style scoped>

</style>